import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import useDeepCompareEffect from 'use-deep-compare-effect';
import useFeatureFlag from '../../../utils/hooks/useFeatureFlag';
import AnnouncementsSidepanel from '../components/announcements-sidepanel';
import {
  closeAnnouncementsSidepanel,
  fetchAnnouncementsFeed,
} from '../../../settings/containers/announcements/announcements-actions';

const AnnouncementsSidepanelContainer = ({
  children,
}) => {
  const [checkFeatureFlag] = useFeatureFlag(
    'showFeedbackWarning',
    'feedbackTitle',
    'feedbackMessage',
  );
  const {
    announcementsSidepanelOpen,
    isSidepanelAnnouncementsLoaded,
    sidepanelAnnouncements,
    isSiepanelFeedback,
    filterOnId,
  } = useSelector(state => state.announcements);
  const dispatch = useDispatch();
  const [shouldOpen, setShouldOpen] = useState(false);

  const initUserSnap = () => {
    dispatch(closeAnnouncementsSidepanel());
    setShouldOpen(false);
    checkFeatureFlag(
      // eslint-disable-next-line no-undef
      () => window.usersnapApi ? window.usersnapApi.open() : UserSnap.start(),
    );
  };

  useEffect(() => {
    if (announcementsSidepanelOpen) {
      if (isSiepanelFeedback) {
        dispatch(fetchAnnouncementsFeed({ isHome: false, category: 'issue' }));
      } else {
        dispatch(fetchAnnouncementsFeed({ isHome: false, announcementId: filterOnId }));
      }
    } else {
      setShouldOpen(false);
    }
  }, [announcementsSidepanelOpen]);

  useDeepCompareEffect(() => {
    if (
      announcementsSidepanelOpen &&
      !isSiepanelFeedback
    ) {
      setShouldOpen(true);
    } else if (
      announcementsSidepanelOpen &&
      isSidepanelAnnouncementsLoaded &&
      sidepanelAnnouncements.length
    ) {
      setShouldOpen(true);
    } else if (announcementsSidepanelOpen &&
      isSidepanelAnnouncementsLoaded &&
      !sidepanelAnnouncements.length &&
      isSiepanelFeedback
    ) {
      initUserSnap();
    }
  }, [
    announcementsSidepanelOpen,
    sidepanelAnnouncements,
    isSidepanelAnnouncementsLoaded,
    isSiepanelFeedback,
  ]);

  return (
    <>
      {announcementsSidepanelOpen && shouldOpen &&
        <AnnouncementsSidepanel
          isFeedback={isSiepanelFeedback}
          onOpenUserSnap={initUserSnap}
        />
      }
      {children}
    </>
  );
};

AnnouncementsSidepanelContainer.propTypes = {
  children: PropTypes.node,
};

export default AnnouncementsSidepanelContainer;
